import { useQuery } from '@tanstack/react-query';
import { backendServices } from '../services';

export function useCompany({ companyId, enabled = true }: { companyId: number | null; enabled?: boolean }) {
    const query = useQuery({
        queryKey: ['Company', companyId],
        queryFn: async () => {
            const api = new backendServices.Apis.CompanyApi();
            const res = await api.getCompany(companyId!);

            return res.data[0];
        },
        enabled: enabled && !!companyId,
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    return query;
}
